import React                                 from "react";
import { useTheme                          } from "styled-components";

import { ArrowBackVector                   } from "src/components/vector/arrow-back";

import { Toolbar                           } from "src/components/features/main/common/toolbar";
import { NavBar                            } from "src/components/features/common/nav-bar";

import { ProductCounterPhotoExampleLayout, 
         layout_dark,
         layout_light, 
         Screen, 
         ScreenBody, 
         Image                              } from "src/containers/main/product-counter-photo-example/layout";

import { Urls                               } from "src/providers/routing";



type ProductCounterPhotoExampleScreenElement = {
  layout: ProductCounterPhotoExampleLayout;
};

const Navigation: React.FC<ProductCounterPhotoExampleScreenElement> = ({ layout }) => {
  return (
    <React.Fragment>
      <NavBar
        variant={layout.navbarVariant}
        label='Пример фото'
        startButtons={[
          {
            id: "back",
            vector: <ArrowBackVector />,
            action: () => {
              Urls.MainRequirementsAndRecommendations.build().navigate()
            },
          },
        ]}
      />
    </React.Fragment>
  );
};

export const ProductCounterPhotoExampleScreen = () => {
  const theme = useTheme();
  const layout = theme.colorScheme === "light" ? layout_light : layout_dark;

  return (
    <Screen layout={layout}>
      <Navigation layout={layout} />
      <ScreenBody layout={layout}>
        <Image layout={layout} src="/prod-counter-photo-example.jpg" alt="image" />
      </ScreenBody>
      <Toolbar variant={layout.toolbarVariant} activeItem='services' />
    </Screen>
  );
}
